import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../progress-indicators/spinner/spinner.component';
import { ProgressComponent } from './progress/progress.component';
import { ProgressCircleComponent } from './progress-circle/progress-circle.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SpinnerComponent, ProgressComponent, ProgressCircleComponent],
  exports: [SpinnerComponent, ProgressComponent, ProgressCircleComponent],
})
export class ProgressIndictatorsModule {}
